// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Functor_Tagged = require("../Data.Functor.Tagged/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Heterogeneous_Folding = require("../Heterogeneous.Folding/index.js");
var Heterogeneous_Mapping = require("../Heterogeneous.Mapping/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Network_Ethereum_Core_Keccak256 = require("../Network.Ethereum.Core.Keccak256/index.js");
var Network_Ethereum_Web3_Api = require("../Network.Ethereum.Web3.Api/index.js");
var Network_Ethereum_Web3_Contract_Events = require("../Network.Ethereum.Web3.Contract.Events/index.js");
var Network_Ethereum_Web3_Solidity_Generic = require("../Network.Ethereum.Web3.Solidity.Generic/index.js");
var Network_Ethereum_Web3_Types_TokenUnit = require("../Network.Ethereum.Web3.Types.TokenUnit/index.js");
var Network_Ethereum_Web3_Types_Types = require("../Network.Ethereum.Web3.Types.Types/index.js");
var Text_Parsing_Parser = require("../Text.Parsing.Parser/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var TxMethod = function (sendTx) {
    this.sendTx = sendTx;
};
var EventFilter = function (eventFilter) {
    this.eventFilter = eventFilter;
};
var CallMethod = function (call) {
    this.call = call;
};
var sendTx = function (dict) {
    return dict.sendTx;
};
var mkDataField = function (dictIsSymbol) {
    return function (dictGeneric) {
        return function (dictRecordFieldsIso) {
            return function (dictGenericABIEncode) {
                return function (v) {
                    return function (r) {
                        var sig = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                        var sel = Network_Ethereum_Core_Keccak256.toSelector(sig);
                        var args = Network_Ethereum_Web3_Solidity_Generic.genericFromRecordFields(dictRecordFieldsIso)(dictGeneric)(r);
                        return Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(sel)(Network_Ethereum_Web3_Solidity_Generic.genericABIEncode(dictGeneric)(dictGenericABIEncode)(args));
                    };
                };
            };
        };
    };
};
var eventFilter = function (dict) {
    return dict.eventFilter;
};
var event = function (dictDecodeEvent) {
    return function (filter) {
        return function (handler) {
            var f = function (v) {
                return {
                    currentBlock: v.value0.currentBlock,
                    windowSize: v.value0.windowSize,
                    trailBy: v.value0.trailBy,
                    initialFilter: v.value0.filters.ev
                };
            };
            return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Network_Ethereum_Web3_Contract_Events["event'"](Heterogeneous_Folding.foldlRecordCons(new Data_Symbol.IsSymbol(function () {
                return "ev";
            }))()(Network_Ethereum_Web3_Contract_Events.foldMinFromBlock)(Heterogeneous_Folding.foldlRecordNil))(Heterogeneous_Folding.foldlRecordCons(new Data_Symbol.IsSymbol(function () {
                return "ev";
            }))()(Network_Ethereum_Web3_Contract_Events.foldMinToBlock)(Heterogeneous_Folding.foldlRecordNil))()(Heterogeneous_Mapping.mapRecordWithIndexCons(new Data_Symbol.IsSymbol(function () {
                return "ev";
            }))(Heterogeneous_Mapping.constMapping(Network_Ethereum_Web3_Contract_Events.modifyFilter))(Heterogeneous_Mapping.mapRecordWithIndexNil)()())()()()(Heterogeneous_Folding.foldlRecordCons(new Data_Symbol.IsSymbol(function () {
                return "ev";
            }))()(Network_Ethereum_Web3_Contract_Events.queryAllLogs(dictDecodeEvent)(new Data_Symbol.IsSymbol(function () {
                return "ev";
            }))()())(Heterogeneous_Folding.foldlRecordNil))({
                ev: filter
            })({
                ev: handler
            })({
                windowSize: 0,
                trailBy: 0
            }))(function (eRes) {
                return Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(f)(eRes));
            });
        };
    };
};
var deployContract = function (dictGeneric) {
    return function (dictGenericABIEncode) {
        return function (txOptions) {
            return function (deployByteCode) {
                return function (args) {
                    var txdata = Data_Lens_Setter.over(Network_Ethereum_Web3_Types_Types["_value"](Network_Ethereum_Web3_Types_TokenUnit.unitTokenUnitSpec(Network_Ethereum_Web3_Types_TokenUnit.unitSpecNoPay))(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Maybe.functorMaybe)(Network_Ethereum_Web3_Types_TokenUnit.convert(Network_Ethereum_Web3_Types_TokenUnit.unitTokenUnitSpec(Network_Ethereum_Web3_Types_TokenUnit.unitSpecNoPay))(Network_Ethereum_Web3_Types_TokenUnit.unitTokenUnitSpec(Network_Ethereum_Web3_Types_TokenUnit.unitSpecMinorUnit))))(Data_Lens_Setter.setJust(Network_Ethereum_Web3_Types_Types["_data"](Data_Profunctor_Strong.strongFn))(Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(deployByteCode)(Network_Ethereum_Web3_Solidity_Generic.genericABIEncode(dictGeneric)(dictGenericABIEncode)(Data_Functor_Tagged.untagged(args))))(txOptions));
                    return Network_Ethereum_Web3_Api.eth_sendTransaction(txdata);
                };
            };
        };
    };
};
var call = function (dict) {
    return dict.call;
};
var _sendTransaction = function (dictIsSymbol) {
    return function (dictGeneric) {
        return function (dictGenericABIEncode) {
            return function (dictTokenUnit) {
                return function (txOptions) {
                    return function (dat) {
                        var txdata = function (d) {
                            return Data_Lens_Setter.over(Network_Ethereum_Web3_Types_Types["_value"](dictTokenUnit)(Data_Profunctor_Strong.strongFn))(Data_Functor.map(Data_Maybe.functorMaybe)(Network_Ethereum_Web3_Types_TokenUnit.convert(dictTokenUnit)(Network_Ethereum_Web3_Types_TokenUnit.unitTokenUnitSpec(Network_Ethereum_Web3_Types_TokenUnit.unitSpecMinorUnit))))(Data_Lens_Setter.set(Network_Ethereum_Web3_Types_Types["_data"](Data_Profunctor_Strong.strongFn))(new Data_Maybe.Just(d))(txOptions));
                        };
                        var sel = Network_Ethereum_Core_Keccak256.toSelector(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value));
                        return Network_Ethereum_Web3_Api.eth_sendTransaction(txdata(Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(sel)(Network_Ethereum_Web3_Solidity_Generic.genericABIEncode(dictGeneric)(dictGenericABIEncode)(Data_Functor_Tagged.untagged(dat)))));
                    };
                };
            };
        };
    };
};
var txmethodAbiEncode = function (dictGeneric) {
    return function (dictGenericABIEncode) {
        return new TxMethod(function (dictTokenUnit) {
            return function (dictIsSymbol) {
                return _sendTransaction(dictIsSymbol)(dictGeneric)(dictGenericABIEncode)(dictTokenUnit);
            };
        });
    };
};
var _call = function (dictIsSymbol) {
    return function (dictGeneric) {
        return function (dictGenericABIEncode) {
            return function (dictGeneric1) {
                return function (dictGenericABIDecode) {
                    return function (txOptions) {
                        return function (cursor) {
                            return function (dat) {
                                var txdata = function (d) {
                                    return Data_Lens_Setter.set(Network_Ethereum_Web3_Types_Types["_data"](Data_Profunctor_Strong.strongFn))(new Data_Maybe.Just(d))(txOptions);
                                };
                                var sig = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                                var sel = Network_Ethereum_Core_Keccak256.toSelector(sig);
                                var fullData = Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(sel)(Network_Ethereum_Web3_Solidity_Generic.genericABIEncode(dictGeneric)(dictGenericABIEncode)(Data_Functor_Tagged.untagged(dat)));
                                return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Network_Ethereum_Web3_Api.eth_call(txdata(Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(sel)(Network_Ethereum_Web3_Solidity_Generic.genericABIEncode(dictGeneric)(dictGenericABIEncode)(Data_Functor_Tagged.untagged(dat)))))(cursor))(function (res) {
                                    var v = Network_Ethereum_Web3_Solidity_Generic.genericFromData(dictGeneric1)(dictGenericABIDecode)(res);
                                    if (v instanceof Data_Either.Left) {
                                        var $37 = Data_Eq.eq(Network_Ethereum_Core_HexString.hexStringEq)(res)(Data_Monoid.mempty(Network_Ethereum_Core_HexString.monoidStringEq));
                                        if ($37) {
                                            return Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)(Data_Either.Left.create(new Network_Ethereum_Web3_Types_Types.NullStorageError({
                                                signature: sig,
                                                "_data": fullData
                                            })));
                                        };
                                        return Network_Ethereum_Web3_Types_Types.throwWeb3(Effect_Exception.error(Data_Show.show(Text_Parsing_Parser.showParseError)(v.value0)));
                                    };
                                    if (v instanceof Data_Either.Right) {
                                        return Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)(new Data_Either.Right(v.value0));
                                    };
                                    throw new Error("Failed pattern match at Network.Ethereum.Web3.Contract (line 131, column 3 - line 141, column 30): " + [ v.constructor.name ]);
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
var callmethodAbiEncode = function (dictGeneric) {
    return function (dictGenericABIEncode) {
        return function (dictGeneric1) {
            return function (dictGenericABIDecode) {
                return new CallMethod(function (dictIsSymbol) {
                    return _call(dictIsSymbol)(dictGeneric)(dictGenericABIEncode)(dictGeneric1)(dictGenericABIDecode);
                });
            };
        };
    };
};
module.exports = {
    EventFilter: EventFilter,
    eventFilter: eventFilter,
    event: event,
    CallMethod: CallMethod,
    call: call,
    TxMethod: TxMethod,
    sendTx: sendTx,
    deployContract: deployContract,
    mkDataField: mkDataField,
    txmethodAbiEncode: txmethodAbiEncode,
    callmethodAbiEncode: callmethodAbiEncode
};
